import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 1. Monkey-patch window.onerror before Webpack's error overlay catches it
const originalOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (
    typeof message === 'string' &&
    (message.includes('ResizeObserver') || message.includes('undelivered notifications'))
  ) {
    return true; // Prevents the error from propagating to Webpack's overlay
  }
  if (originalOnError) {
    return originalOnError.apply(this, arguments);
  }
  return false;
};

// 2. Suppress ResizeObserver console errors in development
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args[0] &&
    typeof args[0] === 'string' &&
    (args[0].includes('ResizeObserver') || args[0].includes('undelivered notifications'))
  ) {
    return;
  }
  originalConsoleError(...args);
};

// 3. Fallback event capture
window.addEventListener(
  'error',
  (e) => {
    if (
      e?.message?.includes('ResizeObserver') ||
      e?.error?.message?.includes('ResizeObserver')
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true // Use capture phase so this executes ahead of other handlers
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();